import React from 'react';
import {QRCodeCanvas} from 'qrcode.react';

export default function QrCode(props) {
    console.log(props.text)
    return (
        <QRCodeCanvas value={props.text} size={props.size}/>
    )
}
